/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { DataTable } from '@scuf/datatable';
import React, { useEffect, useState } from 'react';
import { formatData, getColumnDetails } from './Scope1TableUtils';
import './Scope1TableTheme.scss';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { useFileUploadContext } from '../../../context/FileUploadContext/FileUploadContext';
import moment from 'moment';
import { parseIntBase } from '../../shared/Utils/Constants';
import { useFilterScope1Context } from '../../../context/FilterScope1Context/FilterScope1Context';
import FilterScope1Actions from '../../../context/FilterScope1Context/FilterScope1Actions';
import { useTranslation } from '@scuf/localization';

interface IScopeOneProps {
  data: ScopeOneData[];
  scopeDetails?: string;
  SetHideFooter?: IAny;
  selectedYear?: string;
}

export interface ScopeOneData {
  combustionTypeId: string;
  fuleTypeId: string;
  fuelName: string;
  fuelConsumptionId: string;
  siteId: string;
  emissionFactorId: string;
  emissionFactorUnitByCo2eMeasurement: string;
  emissionFactorValue: number;
  monthWiseFuelConsumptions: MonthWiseFuelConsumption[];
  unit: string;
  year: string;
}
export interface MonthWiseFuelConsumption {
  fuelConsumptionId: string;
  fuelTypeId: string;
  quantity: number;
  month: string;
  year: string;
  isFutureMonth: boolean;
}

function Scope1Table(props: IScopeOneProps) {
  const [state, dispatch] =
    props.scopeDetails === 'ScopeError'
      ? useFilterScope1Context()
      : useFileUploadContext();

  const formattedData = formatData(
    dispatch,
    props.data[0]?.year === undefined
      ? Number(props.selectedYear)
      : parseInt(props?.data[0]?.year, parseIntBase),
    props.data
  );
  const [storeData, setstoreData] = useState(formattedData);
  const [cellVal, setcellData] = useState('');
  const [noFuel, setNoFuel] = useState(false);

  useEffect(() => {
    setstoreData(formattedData);
  }, [props.data]);

  const [t, lng] = useTranslation();
  const fuelTypeTableConfig = getColumnDetails(
    props?.data[0]?.year === undefined
      ? Number(props.selectedYear)
      : parseInt(props?.data[0]?.year, parseIntBase),
    props.scopeDetails,
    t,
    lng
  );

  return (
    <>
      <DataTable data={storeData} className="emaas-scope1table">
        {fuelTypeTableConfig.map((column) => {
          return (
            <DataTable.Column
              field={column.field}
              header={column.header}
              initialWidth={column.width}
              align={column.align as IAny}
              renderer={(cellData) => {
                if (column.field === 'fuelName')
                  return column.renderer(cellData);
                else if (props.scopeDetails === 'ScopeError') {
                  const { renderer } = column as any;
                  return renderer(
                    cellData,
                    storeData,
                    setstoreData,
                    cellVal,
                    setcellData,
                    props.SetHideFooter,
                    setNoFuel,
                    noFuel
                  );
                } else {
                  return column.renderer(cellData);
                }
              }}
            />
          );
        })}
      </DataTable>
    </>
  );
}

export default Scope1Table;
